import { Banner } from "@clipboard-health/ui-components";

export function FileUploaderEmptyState() {
  return (
    <Banner
      intent="disabled"
      illustrationType="document-upload"
      title="No files uploaded yet"
      description="Upload one to get started!"
    />
  );
}
